const BASE_ICONS8_URL = '/infographics/icons8_download/';

const loadIcons8Icon = async (iconId: string) => {
  try {
    const data = await fetch(`${BASE_ICONS8_URL}${iconId}`).then((res) => res.json());

    if (data && data.icon) {
      return data;
    }
  } catch (error) {
    console.error(error);
  }

  return null;
};

export { loadIcons8Icon };
